import React/*, {useState}*/ from 'react';
import Functions, {Particles} from './functions';





/*
	
	other ideas for animation effects

*/

export default class GiphyTenor extends Functions {
  constructor(props) {
    super(props);
		this.process = this.process.bind(this);
		this.paint = this.paint.bind(this);    
  };

	//---- Process the incoming emojis / emotes
	async process(data, image, timeframe, controller) {
		let _data = {};
		_data.canvas = 0;
		_data.canvasdate = Date.now();
		_data.data = data;
		return _data;
	}

	//---- Paint to screen
	async paint(ctx, content, giphytenor, timeframe) {

		let update = false;

		for( let i in giphytenor ) {
			if( giphytenor[i][0] ) {

				if( content ) {
					if( content[giphytenor[i][0].data]?.data ) {
						

						if( Array.isArray(content[giphytenor[i][0].data].data) === true ) {

							
							ctx.drawImage( content[giphytenor[i][0].data].data[giphytenor[i][0].canvas], giphytenor[i][0].x*ctx.canvas.width, giphytenor[i][0].y*ctx.canvas.height, giphytenor[i][0].width*ctx.canvas.width, giphytenor[i][0].height*ctx.canvas.height );

							if( Date.now() > giphytenor[i][0].canvasdate + Math.floor(1000/10) ) {
								giphytenor[i][0].canvas++;
								giphytenor[i][0].canvasdate = Date.now();
								if( giphytenor[i][0].canvas >= content[giphytenor[i][0].data].data.length ) giphytenor[i][0].canvas = 0;
								update = true;
							}


						} else {

							ctx.drawImage( content[giphytenor[i][0].data].data, giphytenor[i][0].x*ctx.canvas.width, giphytenor[i][0].y*ctx.canvas.height, giphytenor[i][0].width*ctx.canvas.width, giphytenor[i][0].height*ctx.canvas.height );
						}

						if( !giphytenor[i][0].ctime ) {
							giphytenor[i][0].ctime = Date.now();
							update = true;
						}


					}
				}
			}
		}

		return update?giphytenor:false;
	}

}
